import { identity, pickBy } from 'lodash';
import { useSelector } from 'react-redux';

import { select } from '../store';
import type { SpinOfDayData } from '../types/CasinoBonus';

export const useBonusGameQuery = (game?: SpinOfDayData) => {
  const { bonusId, bonusCampaignId, numberOfSpins } = game || {};

  const host = useSelector(select.cms.getBrandCode);
  const brand = useSelector(select.cms.getBrandId);
  const site = useSelector(select.cms.getSiteId);
  const platform = useSelector(select.casino.getClientPlatform);

  return pickBy(
    {
      bonusCampaignId,
      bonusId,
      numberOfSpins,
      useNativeClose: true,
      hostapptype: 'WSL',
      host,
      brand,
      site,
      platform
    },
    identity
  );
};

export default useBonusGameQuery;
